import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import ArchivePhotoGrid from './ArchivePhotoGrid'
import ArchiveUserBio from './ArchiveUserBio'
import ArchiveLocationImage from './ArchiveLocationImage'
import ArchiveLocationDescription from './ArchiveLocationDescription'

class ArchiveBottom2017 extends Component {
  constructor(props) {
    super(props)
    this.state = {
      archiveData: props.archiveData,
      isFetching: props.isFetching,
      year: props.year,
      country: 'troupeA',
      placeCountry: 'france',
      visible: 'team'
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      year: nextProps.year,
      archiveData: nextProps.archiveData,
      isFetching: nextProps.isFetching
    })
  }
  changeCountry = (country) => {
    this.setState({
      country: country
    })
  }
  changePlaceCountry = (country) => {
    this.setState({
      placeCountry: country
    })
  }
  changeVisible = (option) => {
    this.setState({
      visible: option
    })
  }
  render() {
    let left, right, menuLeft
    let country = this.state.country
    let placeCountry = this.state.placeCountry
    let visible = this.state.visible
    let active = 'active', inactive = 'inactive'

    if (this.state.visible === 'team') {
      left = <ArchivePhotoGrid photoPath = {'images/sempai2017/'} country={this.state.country} archiveData={this.state && this.state.archiveData} year={this.state.year} isFetching={this.state.isFetching}/>
      right = <ArchiveUserBio  country={this.state.country} archiveData={this.state && this.state.archiveData} year={this.state.year} isFetching={this.state.isFetching}/>
      menuLeft =  <div className="archive-menu-left">
                    <h5 className={country === 'troupeA' ? active : inactive} onClick={this.changeCountry.bind(this, 'troupeA')}>France/ Japan</h5>
                    <h5 className={country === 'troupeB' ? active : inactive} onClick={this.changeCountry.bind(this, 'troupeB')}>Romania/ Indonesia</h5>
                  </div>
    } else {
      menuLeft =  <div className="archive-menu-left">
                    <h5 className={placeCountry === 'france' ? active : inactive} onClick={this.changePlaceCountry.bind(this, 'france')}>France</h5>
                    <h5 className={placeCountry === 'romania' ? active : inactive} onClick={this.changePlaceCountry.bind(this, 'romania')}>Romania</h5>
                    <h5 className={placeCountry === 'japan' ? active : inactive} onClick={this.changePlaceCountry.bind(this, 'japan')}>Japan</h5>
                    <h5 className={placeCountry === 'bali' ? active : inactive} onClick={this.changePlaceCountry.bind(this, 'bali')}>Indonesia</h5>
                  </div>
      left = <ArchiveLocationImage country={this.state.placeCountry} year={this.state.year} isFetching={this.state.isFetching} />
      right = <ArchiveLocationDescription country={this.state.placeCountry} archiveData={this.state && this.state.archiveData} year={this.state.year} isFetching={this.state.isFetching}/>
    }

    return (
      <div className="archive-main">
        <div className="main-grid">
          <ul className="grid group">

            <div className="archive-header">
              <li className="grid-large group archive-menu">
                {menuLeft}
                <div className="archive-menu-right">
                  <h5 className={visible === 'team' ? active : inactive} onClick={this.changeVisible.bind(this, 'team')}>Team</h5>
                  <h5 className={visible === 'place' ? active : inactive} onClick={this.changeVisible.bind(this, 'place')}>Place</h5>
                </div>
              </li>
            </div>

            <li className="grid-large archive-grid">
              {left}
            </li>
            <li className="grid-small inner-left archive-grid">
              {right}
            </li>

          </ul>

        </div>
      </div>
    )
  }
}
ArchiveBottom2017.contextTypes = {
}
ArchiveBottom2017.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(ArchiveBottom2017)



// WEBPACK FOOTER //
// ./src/components/Archive/ArchiveBottom2017.js